module.exports = __webpack_public_path__ + "media/images/payments/shopify-3aa470988d9b979a572be12a0cbd42f1.svg";